module.exports = __webpack_public_path__ + "static/media/search-24px.e0c18ac1.svg";